<template>
  <ul class="p-2">
    <li
      v-for="opcion in configuracionFiltro.opciones"
      :key="opcion.id"
      class="dropdown-item padding-x-5 user-select-none d-flex justify-content-between align-items-center text-landing pointer translate"
      @click="selectOpcion(opcion)">
      {{ opcion.nombre }}
    </li>
  </ul>
</template>

<script setup>
  const props = defineProps({
    configuracionFiltro: {
      type: Object,
      required: true,
    },
  });

  const emit = defineEmits(['selected']);

  function selectOpcion(opcionSelected) {
    emit('selected', {
      id: opcionSelected.id,
      idFiltro: props.configuracionFiltro.id,
      tituloFiltro: props.configuracionFiltro.titulo,
      valor: opcionSelected,
    });
  }
</script>

<style scoped lang="scss">
  ul {
    min-width: 200px;
    width: max-content;
  }

  .dropdown-item {
    &:active {
      background-color: rgba(var(--landing-text-color-rgb, var(--bs-primary-rgb)), 0.1);
    }

    @media screen and (max-width: 768px) {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .padding-x-5 {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
</style>
